export default __webpack_public_path__ + "static/media/soundoff.ac379c44.svg";